class Job {

    constructor(func, ms) {

        this.func = func;
        this.ms = ms;
        this.id = null;

    }

    execute() {

        this.func();

    }

    start(executeOnStart = false) {

        if(executeOnStart) {
            this.func();
        }

        if (this.id === null) {
            this.id = window.setInterval(this.func, this.ms);
        }

    }

    stop() {

        if (this.id !== null) {
            window.clearInterval(this.id);
            this.id = null;
        }

    }

}

export default Job;